import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  pdf
} from '@react-pdf/renderer';
import Logo from "../../assets/logo.png";
import { useState } from 'react';
import { FaFilePdf } from 'react-icons/fa';
import { ImSpinner2 } from 'react-icons/im';

const appUrl = process.env.REACT_APP_URL_BACKEND;

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 11,
    fontFamily: 'Helvetica',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
    borderBottom: '1px solid #ccc',
    paddingBottom: 10,
  },
  image: {
    width: 120,
    height: 50,
    marginRight: 15,
  },
  headerTextContainer: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
    maxHeight: 24,
    overflow: 'hidden',
    lineHeight: 1.2,
  },
  subTitle: { fontSize: 9, marginTop: 2, textAlign: 'center' },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    fontSize: 7
  },
  tableRow: {
    flexDirection: "row",
    font: 7,
  },
  tableColHeader: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#eee",
    padding: 4,
  },
  tableCol: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
  },
  tableCellHeader: {
    fontWeight: "bold",
    fontSize:8
  },
  tableCell: {},
  empresaDatos: {
    fontSize: 7,
    textAlign: 'center',
    marginBottom: 5,
  },
 header: {
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 5,
  borderBottomWidth: 1,
  borderBottomColor: '#ccc',
  paddingBottom: 10,
},

headerTextContainer: {
  flex: 1,
  flexDirection: 'column',
  alignItems: 'flex-start',  // Para que no se centre y quede más ordenado a la izquierda
  paddingLeft: 10,
},

filtersContainer: {
  width: '100%',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 5,
  justifyContent: 'flex-start',
},

filterText: {
  fontSize: 8,
  fontWeight: 'bold',
  marginRight: 12,
  marginBottom: 4,
},

});

const paginateRows = (rows, rowsPerPage) => {
  const pages = [];
  for (let i = 0; i < rows.length; i += rowsPerPage) {
    pages.push(rows.slice(i, i + rowsPerPage));
  }
  return pages;
};

const ExportPdf = ({ headers, rows, filters, titlePdf = "Informe", empresa }) => {
  const imageUrl = empresa?.imagen_sitio
    ? `${appUrl}${empresa.imagen_sitio}`
    : Logo;

  const rowsPerPage = 36; // ajustá esto según el contenido por página
  const paginatedRows = paginateRows(rows, rowsPerPage);
  return (
    <Document>
      {paginatedRows.map((pageRows, pageIndex) => (
        <Page key={pageIndex} size="A4" style={styles.page}>
          {/* ENCABEZADO */}
          <View style={styles.header}>
            <Image src={imageUrl} style={styles.image} />
            <View style={styles.headerTextContainer}>
              <Text style={styles.title}>{empresa.nombre_sitio} - {titlePdf}</Text>
              <Text style={styles.subTitle}>Dirección: {empresa.domicilio_sitio}</Text>
              <Text style={styles.subTitle}>Teléfono: {empresa.telefonos_sitio}</Text>
            </View>
          </View>

          {/* FILTROS ABAJO */}
          {filters.length > 0 && (
            <View style={styles.filtersContainer}>
              {filters.map((f, i) => (
                <Text key={i} style={styles.filterText}>
                  {f.descripcion}: {typeof f.valor === 'object' ? JSON.stringify(f.valor) : f.valor}
                </Text>
              ))}
            </View>
          )}

          {/* TABLA */}
          <View style={styles.table}>
            {/* CABECERA */}
            <View style={styles.tableRow}>
              {headers.map((h, i) => (
                <View key={i} style={{ ...styles.tableColHeader, width: h.width }}>
                  <Text style={styles.tableCellHeader}>{h.headerName}</Text>
                </View>
              ))}
            </View>

            {/* FILAS DE ESTA PÁGINA */}
            {pageRows.map((row, rowIndex) => (
              <View key={rowIndex} style={styles.tableRow}>
                {headers.map((h, colIndex) => (
                  <View key={colIndex} style={{ ...styles.tableCol, width: h.width }}>
                    <Text style={styles.tableCell}>
                      {
                        h.field === 'index'
                          ? pageIndex * rowsPerPage + rowIndex + 1
                          : String(row[h.field] ?? '')
                      }
                    </Text>
                  </View>
                ))}
              </View>
            ))}
          </View>

          {/* PIE DE PÁGINA */}
          <Text
            style={{
              position: 'absolute',
              bottom: 20,
              left: 0,
              right: 0,
              textAlign: 'center',
              fontSize: 9,
              color: '#888',
            }}
          >
            Página {pageIndex + 1} de {paginatedRows.length}
          </Text>
        </Page>
      ))}
    </Document>
  );
};


const ImprimirPDF = ({ headers, rows, filters, titlePdf, empresa }) => {
  const [loading, setLoading] = useState(false);

  const handleImprimir = async () => {
    setLoading(true);
    try {
      const blob = await pdf(
        <ExportPdf headers={headers} rows={rows} filters={filters} titlePdf={titlePdf} empresa={empresa} />
      ).toBlob();
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    } catch (error) {
      console.error('Error al generar el PDF:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={handleImprimir}
        title="Exportar como PDF"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          padding: '8px 12px',
          backgroundColor: '#e53935',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontWeight: 'bold',
          fontSize: '0.9rem',
          transition: 'background 0.3s',
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#c62828')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#e53935')}
        disabled={loading}
      >
        {loading ? (
          <ImSpinner2
            size={18}
            style={{ animation: 'spin 1s linear infinite' }}
          />
        ) : (
          <FaFilePdf size={18} />
        )}
        {loading ? 'Generando...' : 'PDF'}
      </button>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
};

export default ImprimirPDF;